import React, {} from "react"

export default function CapataliseFirstLetter(string) {
   if (!string || typeof string !== 'string') {
      return '';
   }
   return string.charAt(0).toUpperCase() + string.slice(1);
}
